(()=>{
  if(window.HSDPulseVoteAssetLoaded)return;
  window.HSDPulseVoteAssetLoaded=true;

  const voterKey='hsd-pulse-voter-id';
  const normalize=v=>({happy:Number(v?.happy||0),sad:Number(v?.sad||0),death:Number(v?.death||0)});
  const leadingVote=v=>{
    const c=normalize(v),max=Math.max(c.happy,c.sad,c.death);
    if(max<=0)return'neutral';
    const leaders=['happy','sad','death'].filter(s=>c[s]===max);
    return leaders.length===1?leaders[0]:'neutral';
  };
  const setLeadingVote=(root,counts)=>{
    const card=root.closest('[data-pulse-card]');
    if(card)card.dataset.leadingVote=leadingVote(counts);
  };
  const getVoterId=()=>{
    let v=localStorage.getItem(voterKey);
    if(v)return v;
    v=window.crypto?.randomUUID?window.crypto.randomUUID():`hsd-${Date.now()}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(voterKey,v);
    return v;
  };
  const render=(root,counts,choice)=>{
    const c=normalize(counts),t=c.happy+c.sad+c.death;
    ['happy','sad','death'].forEach(s=>{
      const n=root.querySelector(`[data-count="${s}"]`),p=root.querySelector(`[data-percent="${s}"]`),b=root.querySelector(`[data-vote="${s}"]`);
      if(n)n.textContent=c[s];
      if(p)p.textContent=t?`${Math.round(c[s]/t*100)}%`:'0%';
      if(b)b.setAttribute('aria-pressed',choice===s?'true':'false');
    });
  };
  const setDisabled=(root,val)=>root.querySelectorAll('[data-vote]').forEach(b=>b.disabled=val);
  const request=async(url,opts={})=>{
    const controller=new AbortController();
    const timer=setTimeout(()=>controller.abort(),8000);
    try{return await fetch(url,{cache:'no-store',credentials:'omit',...opts,signal:controller.signal})}
    finally{clearTimeout(timer)}
  };

  const init=root=>{
    if(root.dataset.ready==='true')return;
    root.dataset.ready='true';
    const id=root.dataset.articleId;
    const endpoint=(root.dataset.endpoint||'').trim();
    const status=root.querySelector('[data-vote-status]');
    const voterId=getVoterId();
    let counts={happy:0,sad:0,death:0},choice=null;
    setLeadingVote(root,counts);

    const apply=data=>{
      counts=normalize(data);
      choice=data?.choice||null;
      render(root,counts,choice);
      setLeadingVote(root,counts);
      setDisabled(root,false);
      if(status)status.textContent=choice?'VOTE LOCKED':'SHARED TOTALS';
    };
    root.hsdApply=apply;

    const refresh=async()=>{
      if(!endpoint)throw new Error('missing endpoint');
      if(status&&!choice)status.textContent='LOADING TOTALS';
      const r=await request(`${endpoint}?article_id=${encodeURIComponent(id)}&voter_id=${encodeURIComponent(voterId)}`,{headers:{Accept:'application/json'}});
      if(!r.ok)throw new Error(`GET ${r.status}`);
      const data=await r.json();
      apply(data);
      return true;
    };
    root.hsdRefresh=refresh;

    if(!endpoint){
      if(status)status.textContent='VOTE UNAVAILABLE';
      setDisabled(root,true);
      return;
    }

    root.addEventListener('click',async e=>{
      const button=e.target.closest('[data-vote]');
      if(!button||!root.contains(button))return;
      e.preventDefault();
      if(choice){if(status)status.textContent='VOTE LOCKED';return}
      setDisabled(root,true);
      if(status)status.textContent='SENDING VOTE';
      try{
        const r=await request(endpoint,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({article_id:id,vote:button.dataset.vote,voter_id:voterId})});
        const data=await r.json().catch(()=>({}));
        if(r.status===409){
          apply({...normalize(data.counts||data),choice:data.choice||null});
          if(status)status.textContent='VOTE LOCKED';
          return;
        }
        if(!r.ok)throw new Error(`POST ${r.status}`);
        apply({...data,choice:data.choice||button.dataset.vote});
        if(status)status.textContent='VOTE COUNTED';
        setTimeout(()=>{refresh().catch(()=>{})},250);
      }catch(err){
        console.error('HSD Pulse vote submit failed',err);
        if(status)status.textContent='VOTE UNAVAILABLE';
      }finally{setDisabled(root,false)}
    });
  };

  const visibleRoots=scope=>[...scope.querySelectorAll('[data-hsd-vote]')].filter(root=>{
    const card=root.closest('[data-pulse-card]');
    return !card||!card.hidden;
  });

  const batchRefresh=async scope=>{
    const roots=visibleRoots(scope);
    if(!roots.length)return;
    roots.forEach(init);

    const groups=new Map();
    roots.forEach(root=>{
      const endpoint=(root.dataset.endpoint||'').trim();
      const status=root.querySelector('[data-vote-status]');
      if(!endpoint){
        if(status)status.textContent='VOTE UNAVAILABLE';
        setDisabled(root,true);
        return;
      }
      if(!groups.has(endpoint))groups.set(endpoint,[]);
      groups.get(endpoint).push(root);
    });

    const voterId=getVoterId();
    await Promise.all([...groups.entries()].map(async([endpoint,group])=>{
      const ids=[...new Set(group.map(root=>root.dataset.articleId).filter(Boolean))].slice(0,50);
      if(!ids.length)return;
      group.forEach(root=>{
        const status=root.querySelector('[data-vote-status]');
        if(status)status.textContent='LOADING TOTALS';
        setDisabled(root,true);
      });
      try{
        const r=await request(`${endpoint}?article_ids=${encodeURIComponent(ids.join(','))}&voter_id=${encodeURIComponent(voterId)}`,{headers:{Accept:'application/json'}});
        if(!r.ok)throw new Error(`GET ${r.status}`);
        const data=await r.json();
        const articles=data?.articles||{};
        group.forEach(root=>{
          const id=root.dataset.articleId;
          if(!ids.includes(id))return;
          root.hsdApply?.(articles[id]||{happy:0,sad:0,death:0,choice:null});
        });
      }catch(err){
        console.error('HSD Pulse batch totals load failed',err);
        group.forEach(root=>{
          const status=root.querySelector('[data-vote-status]');
          setDisabled(root,false);
          if(status)status.textContent='VOTE UNAVAILABLE';
        });
      }
    }));
  };

  const boot=scope=>scope.querySelectorAll('[data-hsd-vote]').forEach(init);
  window.HSDPulseVote={boot,batchRefresh};
  const start=()=>{boot(document);batchRefresh(document)};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
  window.addEventListener('pageshow',e=>{if(e.persisted)batchRefresh(document)});
  document.addEventListener('shopify:section:load',e=>{boot(e.target);batchRefresh(e.target)});
})();